import { Button, ButtonStyles, ButtonWidth, useTranslation } from '@nextgen-web-framework/all';
import { type AppState } from '@nextgen-web-framework/core';
import { useSelector } from 'react-redux';
import { isGroupOrder, type InitialCartState } from '@commerce-cart-webcomponents/sdk';
import { AddToCartDrawer } from '../add-to-cart-drawer/AddToCartDrawer';
import { AddToCartButton } from '../add-to-cart-button/AddToCartButton';
import styles from './AddToCartWithSubscribe.module.scss';
import { AddToCartWithSubscribeProps } from './types/propsType';

export const AddToCartWithSubscribe = (props: AddToCartWithSubscribeProps) => {
  const t = useTranslation();
  const commerceCartState = useSelector((state: AppState) => state.commerceCart);
  const { cart }: InitialCartState = commerceCartState;
  const subscribeButtonTitle = props.title ?? t('cart.addToCartWithSubscribe.subscribeTitle');

  return (
    <div className={styles['add-to-cart-with-subscription-container']}>
      <div className={styles['add-to-cart-with-subscription-container-button']}>
        <Button
          disabled={props.disableSubscribeButton}
          buttonWidth={ButtonWidth.FULL_WIDTH}
          buttonStyle={ButtonStyles.OUTLINE}
          onClick={props.onSubscribeClick}
          title={subscribeButtonTitle}
        />
      </div>
      <div className={styles['add-to-cart-with-subscription-container-button']}>
        {isGroupOrder(cart.orderType) ? <AddToCartDrawer {...props} /> : <AddToCartButton {...props} />}
      </div>
    </div>
  );
};
